let shadowTaskInputs = null;
let shadowTaskInputPreloader = null;
function getShadowTaskInputs() {
  shadowTaskInputs ??= /* @__PURE__ */ new WeakMap();
  return shadowTaskInputs;
}
function setShadowTaskCasterMeshes(shadowGenerator, casterMeshes) {
  getShadowTaskInputs().set(shadowGenerator, casterMeshes);
  if (!shadowTaskInputPreloader) {
    return;
  }
  shadowGenerator._preloadPending = casterMeshes;
  void shadowTaskInputPreloader(shadowGenerator, casterMeshes).then(
    () => {
      if (shadowGenerator._preloadPending === casterMeshes) {
        shadowGenerator._preloadPending = void 0;
      }
    },
    // Leave the set parked — hence the generator skipped: a failed import means the factory is still
    // missing, and rendering anyway would throw inside the frame with a far less actionable stack.
    (error) => console.error(error)
  );
}
function _getShadowTaskCasterMeshes(shadowGenerator) {
  return shadowTaskInputs?.get(shadowGenerator);
}
function setShadowCasterMaxCascade(mesh, maxCascade) {
  if (maxCascade !== Infinity && (!Number.isInteger(maxCascade) || maxCascade < 0)) {
    throw new RangeError("setShadowCasterMaxCascade requires a non-negative integer or Infinity");
  }
  mesh._shadowMaxCascade = maxCascade === Infinity ? void 0 : maxCascade;
}
function _getShadowCasterMaxCascade(mesh) {
  return mesh._shadowMaxCascade ?? Infinity;
}
function _setShadowTaskInputPreloader(preloader) {
  shadowTaskInputPreloader = preloader;
}

export { _getShadowCasterMaxCascade, _getShadowTaskCasterMeshes, _setShadowTaskInputPreloader, setShadowCasterMaxCascade, setShadowTaskCasterMeshes };
//# sourceMappingURL=shadow-inputs.js.map
